var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value === true)?_c('span',[_c('v-badge',{attrs:{"color":"green accent-3"}})],1):(_vm.value === false)?_c('span',[_c('v-badge',{attrs:{"color":"red accent-3"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }